/*global VeloxWebView */


/**
 * Diagnostic namespace.
 * @namespace diag
 */

var Qty = require('js-quantities');

/**
 * Possible diagnotic modes
 *
 * @enum {string}
 * @memberof diag
 */
var DIAG_MODES = {
    /** Verification mode */
    VER: "VER",
    /** Algae problem */
    ALG: "ALG",
    /** Colored water problem */
    COLOR: "COLOR",
    /** Troubled water problem */
    TROUBLED: "TROUBLED"
};

/**
 * Pool disinfectant
 *
 * @enum {string}
 * @memberOf diag
 */
var DISINFECTANT = {
    /** Chlorine */
    CL: "CL",
    /** Bromine */
    BR: "BR",
    /** Active oxygen*/
    O2: "O2"
};

var POOLTYPE = {
    SPA: "spa",
    POOL: "pool"
};

/**
 * Pool filter types
 *
 * @enum {string}
 * @memberof diag
 */
var FILTER = {
    /** Sand */
    SAND: "SAND",
    /** Glass */
    GLASS: "GLASS",
    /** Cartridge */
    CARTRIDGE: "CARTRIDGE",
    /** Pocket */
    POCKET: "POCKET",
    /** Diatom */
    DIATOM: "DIATOM"
};


/**
 * Type diagnostic input. It represent
 * the data received when proceed to a diagnostic
 *
 * @typedef {object} diag.input
 * @property {object} measures                            Water measures
 * @property {number} measures.alk                    Alkalinity
 * @property {number} measures.ph                          pH
 * @property {number} measures.th                          TH
 * @property {number} measures.clFree                  Free chlorine
 * @property {number} measures.clTotal                  Total chlorine
 * @property {number} measures.br                      Bromine
 * @property {number} measures.salt                    Salt
 * @property {number} measures.cu                      Copper
 * @property {number} measures.fe                      Iron
 * @property {number} measures.stab                    Chlorine stabilizer
 * @property {number} measures.temp                    Temperature
 * @property {number} measures.oxygen                    Oxygen
 * @property {object} options                            Analysis options
 * @property {diag.DIAG_MODES} options.mode            Diagnostic mode
 * @property {boolean} options.filterMaint              Filter maintenance
 * @property {boolean} options.cleanLine                Water line cleaning
 * @property {boolean} options.startUp                  Basin start-up
 * @property {boolean} options.wintering                Wintering
 * @property {boolean} options.mark                    Marks
 * @property {object} pool                                Pool parameters
 * @property {diag.DISINFECTANT} pool.disinf         Used disinfectant
 * @property {number} pool.volume                      Pool volume
 * @property {boolean} pool.saltElect                  Use a salt electrolyzer
 * @property {number} pool.saltRate                    Recommended salt rate
 * @property {diag.FILTER} pool.filter                  Filter types
 * @property {boolean} pool.regul                      Use a regulation
 * @property {Array<diag.PROD_SHOCK>} pool.shock        List of used shock products
 * @property {Array<diag.PROD_LONG>} pool.long          List of used long-term products
 * @property {Array<diag.PROD_ALG>} pool.alg            List of used algae products
 * @property {Array<diag.EQUIP>} pool.equip            List of pool equipments
 */

/**
 * Variables of analyze
 *
 * @typedef {object} diag.variables
 * @property {object} references                          References values
 * @property {number} references.minAlk              Minimum alkalinity
 * @property {number} references.minPH               Minimum pH
 * @property {number} references.loPHlimit           Low pH limit
 * @property {number} references.maxPH               Maximum pH
 * @property {number} references.targetPH            Target pH
 * @property {number} references.targetPHzone        Target pH zone
 * @property {number} references.hiPHlimit           Hight pH limit
 * @property {number} references.minFreeCl           Minimum free chlorine
 * @property {number} references.maxFreeCl           Maxinimum free chlorine
 * @property {number} references.minTotalCl          Minimum total chlorine
 * @property {number} references.maxTotalCl          Maximum total chlorine
 * @property {number} references.minTH               Minimum TH
 * @property {number} references.maxTH               Maximum TH
 * @property {number} references.maxFe               Maximum Fe
 * @property {number} references.maxCu               Maximum Cu
 * @property {number} references.maxStab             Maximum stab
 * @property {number} references.minBr               Minimum bromine
 * @property {number} references.maxBr               Maximum bromine
 * @property {number} references.hiBrlimit           Hight bromine limit
 * @property {object} computed                            Computed values
 * @property {number} computed.alkOk                 Alkalinity is OK
 * @property {number} computed.alkLow                Alkalinity is low
 * @property {number} computed.alkVeryLow            Alkalinity is very low
 * @property {number} computed.phLow                 pH is low
 * @property {number} computed.phVeryLow             pH verylow
 * @property {number} computed.phHigh                pH is high
 * @property {number} computed.phVeryHigh            pH is very high
 * @property {number} computed.phOk                  pH is OK
 * @property {number} computed.thOk                  TH is OK
 * @property {number} computed.thLow                 TH is low
 * @property {number} computed.thHigh                TH is high
 * @property {number} computed.thNotHight            TH is not high
 * @property {number} computed.stabHigh              Stab is high
 * @property {number} computed.feZero                No Fe
 * @property {number} computed.fePresent             Fe != 0
 * @property {number} computed.feLow                 Fe is low
 * @property {number} computed.feHigh                Fe is high
 * @property {number} computed.cuZero                No Cu
 * @property {number} computed.cuPresent             Cu != 0
 * @property {number} computed.cuLow                 Cu is low
 * @property {number} computed.cuHigh                Cu is high
 * @property {number} computed.clLow                 Cl is low
 * @property {number} computed.clOk                  Cl is OK
 * @property {number} computed.clNotHigh             Cl is not high
 * @property {number} computed.clHigh                Cl is high
 * @property {number} computed.clVeryHigh            Cl is very high
 * @property {number} computed.clNotVeryHigh         Cl is not very high
 * @property {number} computed.clTotalHigh           Cl total is high
 * @property {number} computed.saltLow               Salt is low
 * @property {number} computed.brOk                  Br is OK
 * @property {number} computed.brLow                 Br is low
 * @property {number} computed.brNotHigh             Br is not high
 * @property {number} computed.brHigh                Br is high
 * @property {number} computed.brVeryHigh            Br is very high
 * @property {object} dosage                              Dosage values
 * @property {number} dosage.xt1                     Filter
 * @property {number} dosage.xph+                    pH Plus
 * @property {number} dosage.xph-                    pH Moins
 * @property {number} dosage.xtac                    Alca plus
 * @property {number} dosage.x1                      Calcinex
 * @property {number} dosage.x2                      Chloriklar
 * @property {number} dosage.x3                      Chloryte
 * @property {number} dosage.x4                      Chlore 5 fonctions
 * @property {number} dosage.x5                      Superflock Plus
 * @property {number} dosage.x6                      Varitab
 * @property {number} dosage.x7                      Chlorilong 5 Fonctions
 * @property {number} dosage.x8                      Chlorilong
 * @property {number} dosage.x9                      Decalcit Filtre
 * @property {number} dosage.x10                     Aquabrome Regenerator
 * @property {number} dosage.x11                     Bayroshocl
 * @property {number} dosage.x12                     Soft & Easy 20
 * @property {number} dosage.x13                     Desalgine Jet
 * @property {number} dosage.x14                     Chlorifix
 * @property {number} dosage.x15                     Desalgine
 * @property {number} dosage.x16                     Superklar
 * @property {number} dosage.x17                     Filterclean Tab
 * @property {number} dosage.x18                     Chlorilong Bloc
 * @property {number} dosage.x19                     Multibloc
 * @property {number} dosage.x20                     Multilong
 * @property {number} dosage.x21                     Complete & Easy
 * @property {number} dosage.x22                     Soft & Easy 30
 * @property {number} dosage.x23                     Softswim multi
 * @property {number} dosage.x24                     Bayrosoft
 * @property {number} dosage.x24l                    Bayrosoft Light
 * @property {number} dosage.xsel                    Salt
 * @property {number} dosage.maxph+                  Max quantity of pH+ for 1 time
 * @property {number} dosage.maxph-                  Max quantity of pH- for 1 time
 * @property {number} dosage.maxtac                  Max quantity of TAC for 1 time
 *
 */

/**
 * Analyze result
 *
 * @typedef {object} diag.result
 * @property {string} block              the block code
 * @property {string} order              the print order
 */

/**
 * Diag object : represent a diagnostic
 *
 * @example
 * var myDiag = new Diag(myInput) ;
 * var diagResults = myDiag.doFullDiag() ;
 *
 * @class
 * @memberof diag
 *
 * @param {diag.input} input     diagnostic input
 */
function Diag(input) {
    var _self = this;

    var t = VeloxWebView.tr ;

    /**
     * The inputed variables
     * @type {diag.input}
     */
    this.input = input;


    /**
     * The computed variables
     *
     * @type diag.variables
     */
    this.variables = {};


    /**
     * The computed variables
     *
     * @type Array.<diag.result>
     */
    this.results = [];

    /**
     * List of block in the results
     * @type {Array.<diag.string>}
     */
    this.blockList = [] ;

    var HOURS = t("diag.hourUnit");
    var GRAM = "g";
    var KILOGRAM = "kg";
    var ML = "ml";
    var LITER = "l";
    var PASTILLE = t("diag.pellet");
    var PASTILLE_MANY = t("diag.pellets");
    var GALET = t("diag.pebble");
    var GALET_MANY =  t("diag.pebbles");
    var STICK = t("diag.stick");
    var STICK_MANY =  t("diag.sticks");
    var BLOCK =  t("diag.block");
    var BLOCK_MANY =  t("diag.blocks");
    var POCKET =  t("diag.bag");
    var POCKET_MANY =  t("diag.bags");
    var CARTRIDGE =  t("diag.cartridge");
    var CARTRIDGE_MANY = t("diag.cartridges");


    this._sanitizeInput = function(){
        this.input.options.modeTroubled = (this.input.options.mode === DIAG_MODES.TROUBLED);
        this.input.options.modeAlg = (this.input.options.mode === DIAG_MODES.ALG);
        this.input.options.modeColor = (this.input.options.mode === DIAG_MODES.COLOR);
        this.input.options.modeNotColor = !this.input.options.modeColor;
        this.input.options.modeNotAlg = !this.input.options.modeAlg;
        this.input.options.modeVer = (this.input.options.mode === DIAG_MODES.VER);
        this.input.pool.filterGlassSand = (this.input.pool.filter === FILTER.GLASS || this.input.pool.filter === FILTER.SAND);
        this.input.pool.filterCart = (this.input.pool.filter === FILTER.CARTRIDGE || this.input.pool.filter === FILTER.POCKET);
        this.input.pool.cl = (this.input.pool.disinf === DISINFECTANT.CL);
        this.input.pool.isBr = (this.input.pool.disinf === DISINFECTANT.BR);
        this.input.pool.br = (this.input.pool.disinf === DISINFECTANT.BR);
        this.input.pool.o2 = (this.input.pool.disinf === DISINFECTANT.O2);
        this.input.pool.isSpa = (this.input.pool.poolOrSpa === POOLTYPE.SPA);
        this.input.pool.isPool = (this.input.pool.poolOrSpa === POOLTYPE.POOL);
    } ;

    this._sanitizeInput() ;

    this._format = function(value, unit){
        if([CARTRIDGE, PASTILLE, GALET, BLOCK, POCKET, STICK, ""].indexOf(unit) !== -1){
            if(value>1 || isNaN(value)){
                if(unit === CARTRIDGE){ unit = CARTRIDGE_MANY; }
                else if(unit === PASTILLE){ unit = PASTILLE_MANY; }
                else if(unit === GALET){ unit = GALET_MANY; }
                else if(unit === BLOCK){ unit = BLOCK_MANY; }
                else if(unit === POCKET){ unit = POCKET_MANY; }
                else if(unit === STICK){ unit = STICK_MANY; }
            }
            return value+" "+unit ;
        }
        var qty = Qty(value+' '+unit);
        var result = qty ;
        if(unit === GRAM){
            //try kg
            if(qty.to(KILOGRAM).scalar>=1){
                result = qty.to(KILOGRAM).toPrec(0.1) ;
            }
        }else if(unit === ML){
            //try liter
            if(qty.to(LITER).scalar>=1){
                result = qty.to(LITER).toPrec(0.1) ;
            }
        }else if(unit === HOURS){
            // do nothing on hours
        }
        return result.toPrec(0.1).toString() ;
    };

    /**
     * analyze the input and generate all needed variables
     */
    this.computeVariables = function () {
        _self.variables.references = {};
        _self.variables.references.minAlk = 90;
        _self.variables.references.minPH = 7;
        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.loPHlimit = 6.9;
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.loPHlimit = 7.0;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.loPHlimit = 6.9;
        }

        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.maxPH = 7.4;
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.maxPH = 7.6;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.maxPH = 7.4;
        }

        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.targetPH = 7.2;
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.targetPH = 7.4;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.targetPH = 7.2;
        }

        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.targetPHzone = " "+VeloxWebView.tr("report.targetPHzoneCl")+" ";
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.targetPHzone = " "+VeloxWebView.tr("report.targetPHzoneBr")+" ";;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.targetPHzone = " "+VeloxWebView.tr("report.targetPHzoneO2")+" ";;
        }

        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.hiPHlimit = 7.6;
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.hiPHlimit = 7.8;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.hiPHlimit = 7.6;
        }

        _self.variables.references.minFreeCl = 0.5;

        if(_self.input.pool.isSpa){
            _self.variables.references.minFreeCl = 1;
            _self.variables.references.maxFreeCl = 2;
        }else{
            if (_self.input.options.mode === DIAG_MODES.TROUBLED) {
                _self.variables.references.maxFreeCl = 4;
            } else if (_self.input.options.mode === DIAG_MODES.ALG) {
                _self.variables.references.maxFreeCl = 4;
            } else if (_self.input.options.mode === DIAG_MODES.COLOR) {
                _self.variables.references.maxFreeCl = 4;
            } else {
                _self.variables.references.maxFreeCl = 2;
            }
        }

        _self.variables.references.minTotalCl = 0.5;
        _self.variables.references.maxTotalCl = 2.5;
        _self.variables.references.minTH = 125;
        if(VeloxWebView.i18n.getLang() === "de-DE"){
            _self.variables.references.minTH = 0;
        } 
        _self.variables.references.maxTH = 185;
        _self.variables.references.maxFe = 0;
        _self.variables.references.maxCu = 0;

        if (_self.input.pool.disinf === DISINFECTANT.CL) {
            _self.variables.references.maxStab = 100;
        } else if (_self.input.pool.disinf === DISINFECTANT.BR) {
            _self.variables.references.maxStab = 0;
        } else if (_self.input.pool.disinf === DISINFECTANT.O2) {
            _self.variables.references.maxStab = 150;
        }

        _self.variables.references.minBr = 1;
        
        if(_self.input.pool.isSpa){
            _self.variables.references.minBr = 2;
            _self.variables.references.maxBr = 5;
        }else{
            if (_self.input.options.mode === DIAG_MODES.TROUBLED) {
                _self.variables.references.maxBr = 5;
            } else if (_self.input.options.mode === DIAG_MODES.ALG) {
                _self.variables.references.maxBr = 5;
            } else if (_self.input.options.mode === DIAG_MODES.COLOR) {
                _self.variables.references.maxBr = 5;
            } else {
                _self.variables.references.maxBr = 3;
            }
        }


        _self.variables.references.maxPhos = 0.2;


        var mes = _self.input.measures;
        var ref = _self.variables.references;
        var pool = _self.input.pool;

        _self.variables.references.hiBrlimit = 8;
        _self.variables.computed = {};


        mes.displayedAlk = mes.alk ;
        if(mes.alk === undefined || mes.alk === null){
            mes.alk = 91;
            mes.displayedAlk = "" ;
        }else{
            mes.displayedAlk = Math.round(mes.displayedAlk*10)/10 ;
        }
        mes.displayedTh = mes.th ;
        if(mes.th === undefined || mes.th === null){
            mes.th = 151;
            mes.displayedTh = "" ;
        }else{
            mes.displayedTh = Math.round(mes.displayedTh*10)/10 ;
        }
        mes.displayedClTotal = mes.clTotal ;
        if(mes.clTotal === undefined || mes.clTotal === null){
            mes.clTotal = mes.clFree;
            mes.displayedClTotal = "" ;
        }else{
            mes.displayedClTotal = Math.round(mes.displayedClTotal*10)/10 ;
        }
        mes.displayedFe = mes.fe  ;
        if(mes.fe === undefined || mes.fe === null){
            mes.fe = 0;
            mes.displayedFe = "" ;
        }else{
            mes.displayedFe = Math.round(mes.displayedFe*10)/10 ;
        }
        mes.displayedCu = mes.cu ;
        if(mes.cu === undefined || mes.cu === null){
            mes.cu = 0;
            mes.displayedCu = "" ;
        }else{
            mes.displayedCu = Math.round(mes.displayedCu*10)/10 ;
        }
        mes.displayedStab = mes.stab ;
        if(mes.stab === undefined || mes.stab === null){
            mes.stab = 99;
            mes.displayedStab = "" ;
        }else{
            mes.displayedStab = Math.round(mes.displayedStab*10)/10 ;
        }

        mes.displayedSalt = mes.salt ;
        if(mes.salt === undefined || mes.salt === null){
            mes.displayedSalt = "" ;
        }else{
            mes.displayedSalt = Math.round(mes.displayedSalt*10)/10 ;
        }
        
        mes.displayedSaltDisolved = mes.salt_disolved ;
        if(mes.salt_disolved === undefined || mes.salt_disolved === null){
            mes.displayedSaltDisolved = "" ;
        }else{
            mes.displayedSaltDisolved = Math.round(mes.displayedSaltDisolved*10)/10 ;
        }

        mes.displayedPhos = mes.phos ;
        if(mes.phos === undefined || mes.phos === null){
            mes.displayedPhos = "" ;
        }else{
            mes.displayedPhos = Math.round(mes.displayedPhos*10)/10 ;
        }
        
        mes.displayedPH = mes.ph ;
        if(mes.ph === undefined || mes.ph === null){
            mes.displayedPH = "" ;
        }else{
            mes.displayedPH = Math.round(mes.displayedPH*10)/10 ;
        }
        
        mes.displayedClFree = mes.clFree ;
        if(mes.clFree === undefined || mes.clFree === null){
            mes.displayedClFree = "" ;
        }else{
            mes.displayedClFree = Math.round(mes.displayedClFree*10)/10 ;
        }
        
        
        
        mes.displayedBr = mes.br ;
        if(mes.br === undefined || mes.br === null){
            mes.displayedBr = "" ;
        }else{
            mes.displayedBr = Math.round(mes.displayedBr*10)/10 ;
        }

        mes.displayedSaltRate = pool.saltRate + " g/l" ;
        if(pool.saltRate === undefined || pool.saltRate === null){
            mes.displayedSaltRate = "" ;
        }

        var askedAnalyzes = [];
        askedAnalyzes.push(t("diag.options.modes."+_self.input.options.mode )) ;
        ["filterMaint","cleanLine","startUp","wintering","mark","markSpa",
        "mousse","troubleWater", "greenWaterCrystal", "greenWaterAlgae", "textAlg", "textTroubled"].forEach(function(f){
            if(_self.input.options[f]){
                askedAnalyzes.push(t("diag.options."+f)) ;
            }
        }) ;
        mes.askedAnalyzesLabel = askedAnalyzes.join(" / ") ;



        _self.variables.computed.alkOk = (mes.alk >= ref.minAlk);
        _self.variables.computed.alkLow = (mes.alk < ref.minAlk);
        _self.variables.computed.alkNotLow = !_self.variables.computed.alkLow;
        _self.variables.computed.alkVeryLow = (mes.alk < 80 );
        _self.variables.computed.phLow = (mes.ph < ref.minPH );
        _self.variables.computed.phVeryLow = (mes.ph < ref.loPHlimit );
        _self.variables.computed.phHigh = (mes.ph > ref.maxPH );
        _self.variables.computed.phVeryHigh = (mes.ph > ref.hiPHlimit );
        _self.variables.computed.phOk = (mes.ph >= ref.minPH && mes.ph <= ref.maxPH);
        _self.variables.computed.thOk = (mes.th >= ref.minTH && mes.th <= ref.maxTH);
        _self.variables.computed.thLow = (mes.th < ref.minTH);
        _self.variables.computed.thHigh = (mes.th > ref.maxTH);
        _self.variables.computed.thNotHight = !_self.variables.computed.thHigh;
        _self.variables.computed.stabHigh = (mes.stab > ref.maxStab);
        _self.variables.computed.feZero = (mes.fe < 0.05);
        _self.variables.computed.fePresent = !_self.variables.computed.feZero;
        _self.variables.computed.feLow = (mes.fe >= 0.05 && mes.fe <= 0.1);
        _self.variables.computed.feHigh = (mes.fe > 0.1);
        _self.variables.computed.cuZero = (mes.cu < 0.05);
        _self.variables.computed.cuPresent = !_self.variables.computed.cuZero;
        _self.variables.computed.cuLow = (mes.cu >= 0.05 && mes.cu <= 0.2);
        _self.variables.computed.cuHigh = (mes.cu > 0.2);
        _self.variables.computed.clLow = (mes.clFree < ref.minFreeCl);
        _self.variables.computed.clOk = (mes.clFree >= ref.minFreeCl && mes.clFree <= ref.maxFreeCl);
        _self.variables.computed.clNotHigh = (mes.clFree <= ref.maxFreeCl);
        _self.variables.computed.clHigh = (mes.clFree > ref.maxFreeCl && mes.clFree <= 8);
        _self.variables.computed.clVeryHigh = (mes.clFree > 8);
        _self.variables.computed.clNotVeryHigh = !_self.variables.computed.clVeryHigh;
        _self.variables.computed.clDiff = (mes.clFree !== null && mes.clFree !== undefined && mes.clTotal !== null && mes.clTotal !== undefined)?(Math.round((mes.clTotal - mes.clFree) * 100) / 100):0 ;
        _self.variables.computed.clTotalHigh = (mes.clFree !== null && mes.clFree !== undefined && mes.clTotal !== null && mes.clTotal !== undefined && (mes.clTotal - mes.clFree).toFixed(1) > 0.6);
        _self.variables.computed.saltLow = (mes.salt !== null && mes.salt !== undefined && mes.salt < pool.saltRate);
        _self.variables.computed.brOk = (mes.br >= ref.minBr && mes.br <= ref.maxBr);
        _self.variables.computed.brLow = (mes.br < ref.minBr);
        _self.variables.computed.brNotHigh = (mes.br <= ref.maxBr);
        _self.variables.computed.brHigh = (mes.br > ref.maxBr && mes.br <= ref.hiBrlimit);
        _self.variables.computed.brVeryHigh = (mes.br > ref.hiBrlimit);
        _self.variables.computed.poolMore8m3 = (pool.volume >= 8) ;
        _self.variables.computed.phosOk = (!mes.phos || (mes.phos && mes.phos <= ref.maxPhos));
        _self.variables.computed.phosHigh = (mes.phos && mes.phos > ref.maxPhos);
        _self.variables.computed.tempNotEmpty = (mes.temp);
        _self.variables.computed.isChlorineNotElec = _self.input.pool.disinf === DISINFECTANT.CL && !_self.input.pool.saltElect;
        _self.variables.computed.isNotChlorineOrElec = !_self.variables.computed.isChlorineNotElec;


        mes.displayedClDiff = _self.variables.computed.clDiff ;
        if(_self.variables.computed.clDiff === undefined || _self.variables.computed.clDiff === null){
            mes.displayedClDiff = "" ;
        }else{
            mes.displayedClDiff = Math.round(mes.displayedClDiff*10)/10 ;
        }

        _self.variables.dosage = {};
        if(mes.temp){
            if(mes.temp / 2 > 24){
                _self.variables.dosage.xt1 = _self._format(24, HOURS);
            }else{
                _self.variables.dosage.xt1 = _self._format(mes.temp / 2, HOURS);
            }
        }

        _self.variables.dosage["xph+"] = _self._format((10 * pool.volume) * ( (ref.targetPH - mes.ph) * 10 ), GRAM);
        _self.variables.dosage["xph-"] = _self._format((10 * pool.volume) * ( (mes.ph - ref.targetPH) * 10 ), GRAM);
        _self.variables.dosage["xphspa+"] = _self._format((10 * pool.volume) * ( (ref.targetPH - mes.ph) * 10 ), GRAM);
        _self.variables.dosage["xphspa-"] = _self._format((10 * pool.volume) * ( (mes.ph - ref.targetPH) * 10 ), GRAM);
        _self.variables.dosage.xtac = _self._format((18 * pool.volume) * ( (100 - mes.alk) * 0.1 ), GRAM);

        _self.variables.dosage.x1 = _self._format(30 * pool.volume, ML);
        _self.variables.dosage.x2 = _self._format(1 * pool.volume, PASTILLE);
        _self.variables.dosage.x3 = _self._format(15 * pool.volume, GRAM);
        if (pool.volume <= 3) {
            _self.variables.dosage.x4 = 1;
        } else if (pool.volume <= 6) {
            _self.variables.dosage.x4 = 2;
        } else if (pool.volume <= 9) {
            _self.variables.dosage.x4 = 3;
        } else if (pool.volume <= 12) {
            _self.variables.dosage.x4 = 4;
        } else if (pool.volume <= 14) {
            _self.variables.dosage.x4 = 5;
        } else {
            _self.variables.dosage.x4 = t("diag.some");
        }
        _self.variables.dosage.x4 = _self._format(_self.variables.dosage.x4, PASTILLE);

        if (pool.volume <= 50) {
            _self.variables.dosage.x5 = 1;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.x5 = 2;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x5 = 3;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.x5 = 4;
        } else {
            _self.variables.dosage.x5 = t("diag.some");
        }
        _self.variables.dosage.x5 = _self._format(_self.variables.dosage.x5, CARTRIDGE);

        if (pool.volume <= 30) {
            _self.variables.dosage.x6 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x6 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x6 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x6 = 4;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x6 = 5;
        } else if (pool.volume <= 180) {
            _self.variables.dosage.x6 = 6;
        } else if (pool.volume <= 210) {
            _self.variables.dosage.x6 = 7;
        } else {
            _self.variables.dosage.x6 = t("diag.some");
        }
        _self.variables.dosage.x6 = _self._format(_self.variables.dosage.x6, GALET);

        if (pool.volume <= 30) {
            _self.variables.dosage.x7 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x7 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x7 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x7 = 4;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x7 = 5;
        } else if (pool.volume <= 180) {
            _self.variables.dosage.x7 = 6;
        } else if (pool.volume <= 210) {
            _self.variables.dosage.x7 = 7;
        } else {
            _self.variables.dosage.x7 = t("diag.some");
        }
        _self.variables.dosage.x7 = _self._format(_self.variables.dosage.x7, GALET);

        if (pool.volume <= 30) {
            _self.variables.dosage.x8 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x8 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x8 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x8 = 4;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x8 = 5;
        } else if (pool.volume <= 180) {
            _self.variables.dosage.x8 = 6;
        } else if (pool.volume <= 210) {
            _self.variables.dosage.x8 = 7;
        } else {
            _self.variables.dosage.x8 = t("diag.some");
        }
        _self.variables.dosage.x8 = _self._format(_self.variables.dosage.x8, GALET);

        _self.variables.dosage.x9 = _self._format(10 * pool.volume, GRAM);
        _self.variables.dosage.x10 = _self._format(10 * pool.volume, GRAM);
        _self.variables.dosage.x11 = _self._format(0.4 * pool.volume, LITER);
        _self.variables.dosage.x11l = _self._format(0.3 * pool.volume, LITER);

        if (pool.volume <= 20) {
            _self.variables.dosage.x12 = 1;
        } else if (pool.volume <= 40) {
            _self.variables.dosage.x12 = 2;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x12 = 3;
        } else if (pool.volume <= 80) {
            _self.variables.dosage.x12 = 4;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.x12 = 5;
        } else {
            _self.variables.dosage.x12 = t("diag.some");
        }
        _self.variables.dosage.x12 = _self._format(_self.variables.dosage.x12, POCKET);

        _self.variables.dosage.x13 = _self._format(5 * pool.volume, ML);
        _self.variables.dosage.x14 = _self._format(20 * pool.volume, GRAM);
        _self.variables.dosage.x15 = _self._format(5 * pool.volume, ML);
        _self.variables.dosage.x16 = _self._format(1 * pool.volume, ML);

        if (pool.volume <= 15) {
            _self.variables.dosage.x17 = 1;
        } else if (pool.volume <= 30) {
            _self.variables.dosage.x17 = 2;
        } else if (pool.volume <= 45) {
            _self.variables.dosage.x17 = 3;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x17 = 4;
        } else if (pool.volume <= 75) {
            _self.variables.dosage.x17 = 5;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x17 = 6;
        } else if (pool.volume <= 105) {
            _self.variables.dosage.x17 = 7;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x17 = 8;
        } else if (pool.volume <= 135) {
            _self.variables.dosage.x17 = 9;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x17 = 10;
        } else {
            _self.variables.dosage.x17 = t("diag.some");
        }
        _self.variables.dosage.x17 = _self._format(_self.variables.dosage.x17, GALET);

        if (pool.volume <= 30) {
            _self.variables.dosage.x18 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x18 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x18 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x18 = 4;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x18 = 5;
        } else if (pool.volume <= 180) {
            _self.variables.dosage.x18 = 6;
        } else if (pool.volume <= 210) {
            _self.variables.dosage.x18 = 7;
        } else {
            _self.variables.dosage.x18 = t("diag.some");
        }
        _self.variables.dosage.x18 = _self.variables.dosage.x18;

        if (pool.volume <= 30) {
            _self.variables.dosage.x19 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x19 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x19 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x19 = 4;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x19 = 5;
        } else if (pool.volume <= 180) {
            _self.variables.dosage.x19 = 6;
        } else if (pool.volume <= 210) {
            _self.variables.dosage.x19 = 7;
        } else {
            _self.variables.dosage.x19 = t("diag.some");
        }
        _self.variables.dosage.x19 = _self.variables.dosage.x19;

        if (pool.volume <= 50) {
            _self.variables.dosage.x20 = 1;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.x20 = 2;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.x20 = 3;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.x20 = 4;
        } else {
            _self.variables.dosage.x20 = t("diag.some");
        }
        _self.variables.dosage.x20 = _self.variables.dosage.x20;

        if (pool.volume <= 20) {
            _self.variables.dosage.x21 = 1;
        } else if (pool.volume <= 40) {
            _self.variables.dosage.x21 = 2;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x21 = 3;
        } else if (pool.volume <= 80) {
            _self.variables.dosage.x21 = 4;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.x21 = 5;
        } else {
            _self.variables.dosage.x21 = t("diag.some");
        }
        _self.variables.dosage.x21 = _self._format(_self.variables.dosage.x21, POCKET);

        if (pool.volume <= 30) {
            _self.variables.dosage.x22 = 1;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x22 = 2;
        } else if (pool.volume <= 90) {
            _self.variables.dosage.x22 = 3;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x22 = 4;
        } else {
            _self.variables.dosage.x22 = t("diag.some");
        }
        _self.variables.dosage.x22 = _self._format(_self.variables.dosage.x22, POCKET);

        _self.variables.dosage.x23 = _self._format(0.15 * pool.volume, LITER);
        _self.variables.dosage.x24 = _self._format(0.05 * pool.volume, LITER);
        _self.variables.dosage.x24l = _self._format(0.15 * pool.volume, LITER);
        _self.variables.dosage.xsel = _self._format((pool.saltRate - mes.salt) * pool.volume, KILOGRAM);
        _self.variables.dosage["maxph+"] = _self._format(30 * pool.volume, GRAM);
        _self.variables.dosage["maxph-"] = _self._format(40 * pool.volume, GRAM);
        _self.variables.dosage.maxtac = _self._format(36 * pool.volume, GRAM);
        _self.variables.dosage.x25 = _self._format(5 * pool.volume, ML);
        _self.variables.dosage.x26 = _self._format(30 * pool.volume, ML);
        _self.variables.dosage.x27 = _self._format(5 * pool.volume, GRAM);
        _self.variables.dosage.x28 = _self._format(20 * pool.volume, GRAM);
        
        
        _self.variables.dosage.x28 = _self._format(20 * pool.volume, GRAM);
        
        if (pool.volume <= 1.2) {
            _self.variables.dosage.x29 = 1;
        } else if (pool.volume <= 2.2) {
            _self.variables.dosage.x29 = 2;
        } else if (pool.volume <= 3.2) {
            _self.variables.dosage.x29 = 3;
        } else if (pool.volume <= 4.9) {
            _self.variables.dosage.x29 = 4;
        } else {
            _self.variables.dosage.x29 = t("diag.some");
        }
        _self.variables.dosage.x29 = _self._format(_self.variables.dosage.x29, POCKET);
        
        
        if (pool.volume <= 1.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 1, to : 2});
        } else if (pool.volume <= 2.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 2, to : 4});
        } else if (pool.volume <= 3.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 3, to : 6});
        } else if (pool.volume <= 4.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 4, to : 8});
        } else if (pool.volume <= 5.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 5, to : 10});
        } else if (pool.volume <= 6.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 6, to : 12});
        } else if (pool.volume <= 7.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 7, to : 14});
        } else if (pool.volume <= 8.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 8, to : 16});
        } else if (pool.volume <= 9.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 9, to : 18});
        } else if (pool.volume <= 10.2) {
            _self.variables.dosage.x30 = t("diag.qtyFromTo", {from : 10, to : 20});
        } else {
            _self.variables.dosage.x30 = t("diag.some");
            _self.variables.computed.noX30Qty= true;
        }
        _self.variables.dosage.x30 = _self._format(_self.variables.dosage.x30, PASTILLE);
        
        _self.variables.dosage.x31 = _self._format(10 * pool.volume, GRAM);
        _self.variables.dosage.x32 = _self._format(20 * pool.volume, ML);
        _self.variables.dosage.x33 = _self._format(10 * pool.volume, ML);
        _self.variables.dosage.x34 = _self._format(10 * pool.volume, ML);
        _self.variables.dosage.x35 = _self._format(200 * pool.volume, GRAM);
        _self.variables.dosage.x36 = _self._format(4 * pool.volume, ML);


        if (pool.volume <= 20) {
            _self.variables.dosage.x37 = 1;
        } else if (pool.volume <= 40) {
            _self.variables.dosage.x37 = 2;
        } else if (pool.volume <= 60) {
            _self.variables.dosage.x37 = 3;
        } else if (pool.volume <= 80) {
            _self.variables.dosage.x37 = 4;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.x37 = 5;
        } else if (pool.volume <= 120) {
            _self.variables.dosage.x37 = 6;
        } else {
            _self.variables.dosage.x37 = t("diag.some");
        }
        _self.variables.dosage.x37 = _self._format(_self.variables.dosage.x37, STICK);
        
        
        _self.variables.dosage.x38 = _self._format(25 * pool.volume, ML);
        _self.variables.dosage.x39 = _self._format(25 * pool.volume, ML);

        
        _self.variables.dosage["aph+"] = _self._format((10 * pool.volume) * ( (ref.targetPH - mes.ph) * 10 ), GRAM);
        _self.variables.dosage["aph-"] = _self._format((10 * pool.volume) * ( (mes.ph - ref.targetPH) * 10 ), GRAM);
        
        _self.variables.dosage.atac = _self._format((18 * pool.volume) * ( (100 - mes.alk) * 0.1 ), GRAM);
        _self.variables.dosage.a1 = _self._format(60 * pool.volume, ML);
        _self.variables.dosage.a2 = _self._format(1 * pool.volume, PASTILLE);
        _self.variables.dosage.a3 = _self._format(20 * pool.volume, GRAM);
        if (pool.volume <= 25) {
            _self.variables.dosage.a6 = 1;
        } else if (pool.volume <= 50) {
            _self.variables.dosage.a6 = 2;
        } else if (pool.volume <= 75) {
            _self.variables.dosage.a6 = 3;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.a6 = 4;
        } else if (pool.volume <= 125) {
            _self.variables.dosage.a6 = 5;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.a6 = 6;
        } else if (pool.volume <= 175) {
            _self.variables.dosage.a6 = 7;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.a6 = 8;
        } else {
            _self.variables.dosage.a6 = t("diag.some");
        }
        _self.variables.dosage.a6 = _self._format(_self.variables.dosage.a6, GALET);
    
        if (pool.volume <= 50) {
            _self.variables.dosage.a7 = 1;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.a7 = 2;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.a7 = 3;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.a7 = 4;
        } else if (pool.volume <= 250) {
            _self.variables.dosage.a7 = 5;
        } else {
            _self.variables.dosage.a7 = t("diag.some");
        }
        _self.variables.dosage.a7 = _self._format(_self.variables.dosage.a7, GALET);
    
        if (pool.volume <= 25) {
            _self.variables.dosage.a8 = 1;
        } else if (pool.volume <= 50) {
            _self.variables.dosage.a8 = 2;
        } else if (pool.volume <= 75) {
            _self.variables.dosage.a8 = 3;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.a8 = 4;
        } else if (pool.volume <= 125) {
            _self.variables.dosage.a8 = 5;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.a8 = 6;
        } else if (pool.volume <= 175) {
            _self.variables.dosage.a8 = 7;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.a8 = 8;
        } else {
            _self.variables.dosage.a8 = t("diag.some");
        }
        _self.variables.dosage.a8 = _self._format(_self.variables.dosage.a8, GALET);
    
        if (pool.volume <= 50) {
            _self.variables.dosage.a9 = 1;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.a9 = 2;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.a9 = 3;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.a9 = 4;
        } else if (pool.volume <= 250) {
            _self.variables.dosage.a9 = 5;
        } else {
            _self.variables.dosage.a9 = t("diag.some");
        }
        _self.variables.dosage.a9 = _self._format(_self.variables.dosage.a9, GALET);
    
        _self.variables.dosage.a14 = _self._format(10 * pool.volume, GRAM);
        _self.variables.dosage.a18 = _self._format(0.4 * pool.volume, LITER);
        _self.variables.dosage.a19 = _self._format(10 * pool.volume, ML);
        _self.variables.dosage.a20 = _self._format(10 * pool.volume, ML);
    
        if (pool.volume <= 50) {
            _self.variables.dosage.a22 = 1;
        } else if (pool.volume <= 100) {
            _self.variables.dosage.a22 = 2;
        } else if (pool.volume <= 150) {
            _self.variables.dosage.a22 = 3;
        } else if (pool.volume <= 200) {
            _self.variables.dosage.a22 = 4;
        } else {
            _self.variables.dosage.a22 = t("diag.some");
        }
        _self.variables.dosage.a22 = _self._format(_self.variables.dosage.a22, "");
    
        _self.variables.dosage.asel = _self._format((pool.saltRate - mes.salt) * pool.volume, KILOGRAM);
        _self.variables.dosage["maaph+"] = _self._format(30 * pool.volume, GRAM);
        _self.variables.dosage["maaph-"] = _self._format(40 * pool.volume, GRAM);
        _self.variables.dosage.maatac = _self._format(36 * pool.volume, GRAM);
        
        _self.variables.dosage.a27 = _self._format(30 * pool.volume, ML);
        _self.variables.dosage.a28 = _self._format(30 * pool.volume, ML);
        _self.variables.dosage.a29 = _self._format(30 * pool.volume, ML);
        
    };


    this.rules = [
        {block: "FILTRATION",   order: "10.100", rule: ["input.pool.isPool"]    },
        {block: "REGUL1",       order: "10.101", rule: ["input.pool.isPool", "input.pool.regul"]    },
        {block: "SEL",          order: "10.102", rule: ["input.pool.isPool", "input.pool.cl", "input.pool.saltElect", "variables.computed.saltLow"]    },
        {block: "TH1",          order: "10.103", rule: ["input.pool.isPool", "variables.computed.thHigh"]    },
        {block: "TH2",          order: "10.104", rule: ["input.pool.isPool", "variables.computed.thLow"]    },
        {block: "TAC2",         order: "10.105", rule: ["input.pool.isPool", "variables.computed.alkLow"]    },
        {block: "PH1",          order: "10.106", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.cl", "variables.computed.phLow" ]    },
        {block: "PH1",          order: "10.106", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.o2", "variables.computed.phLow" ]    },
        {block: "PH2",          order: "10.107", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.cl", "variables.computed.phHigh" ]    },
        {block: "PH2",          order: "10.107", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.o2", "variables.computed.phHigh" ]    },
        {block: "PH4",          order: "10.108", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.br", "variables.computed.phLow" ]    },
        {block: "PH5",          order: "10.108", rule: ["input.pool.isPool", "variables.computed.alkNotLow", "input.pool.br", "variables.computed.phHigh"]    },
        {block: "PH7",          order: "10.110", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.br", "variables.computed.phLow" ]    },
        {block: "PH7",          order: "10.110", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.cl", "variables.computed.phLow" ]    },
        {block: "PH7",          order: "10.110", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.o2", "variables.computed.phLow" ]    },
        {block: "PH8",          order: "10.111", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.cl", "variables.computed.phOk" ]    },
        {block: "PH8",          order: "10.111", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.o2", "variables.computed.phOk" ]    },
        {block: "PH9",          order: "10.112", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.cl", "variables.computed.phHigh" ]    },
        {block: "PH9",          order: "10.112", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.o2", "variables.computed.phHigh" ]    },
        {block: "PH10",         order: "10.113", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.br", "variables.computed.phOk" ]    },
        {block: "PH11",         order: "10.114", rule: ["input.pool.isPool", "variables.computed.alkLow", "input.pool.br", "variables.computed.phHigh" ]    },
        {block: "CL1",          order: "10.115", rule: ["input.pool.isPool", "input.pool.cl", "variables.computed.clLow"]    },
        {block: "CL3",          order: "10.117", rule: ["input.pool.isPool", "input.pool.cl", "variables.computed.clHigh"]    },
        {block: "CL4",          order: "10.118", rule: ["input.pool.isPool", "input.pool.cl", "variables.computed.clVeryHigh"]    },
        {block: "CL6",          order: "10.119", rule: ["input.pool.isPool", "input.pool.cl", "variables.computed.clTotalHigh", "variables.computed.clNotVeryHigh" ]    },
        {block: "BR1",          order: "10.120", rule: ["input.pool.isPool", "input.pool.br", "variables.computed.brLow" ]    },
        {block: "BR3",          order: "10.122", rule: ["input.pool.isPool", "input.pool.br", "variables.computed.brHigh"]    },
        {block: "BR4",          order: "10.123", rule: ["input.pool.isPool", "input.pool.br", "variables.computed.brVeryHigh"]    },
        {block: "STAB2",        order: "10.124", rule: ["input.pool.isPool", "input.pool.cl", "variables.computed.stabHigh" ]    },
        {block: "STAB4",        order: "10.125", rule: ["input.pool.isPool", "input.pool.o2", "variables.computed.stabHigh" ]    },
        {block: "FER2",         order: "10.126", rule: ["input.pool.isPool", "variables.computed.fePresent" ]    },
        {block: "CU2",          order: "10.127", rule: ["input.pool.isPool", "variables.computed.cuPresent"]    },
        {block: "PHOSPHATE2",   order: "10.128", rule: ["input.pool.isPool", "variables.computed.phosHigh" ]    },
        
        {block: "RECO1",        order: "20.101", rule: ["input.pool.isPool" ]    },
        {block: "RECO2",        order: "20.102", rule: ["input.pool.isPool" ]    },
        {block: "RECO3",        order: "20.103", rule: ["input.pool.isPool" , "input.pool.filterGlassSand", "variables.computed.poolMore8m3"]    },
        {block: "RECO4",        order: "20.104", rule: ["input.pool.isPool" ]    },
        {block: "RECO5",        order: "20.105", rule: ["input.pool.isPool",  "input.pool.cl", ]    },
        {block: "RECO6",        order: "20.106", rule: ["input.pool.isPool",  "input.pool.br" ]    },
        {block: "RECO7",        order: "20.107", rule: ["input.pool.isPool",  "input.pool.o2" ]    },
        {block: "RECO8",        order: "20.108", rule: ["input.pool.isPool" ]    },
        {block: "RECO9",        order: "20.109", rule: ["input.pool.isPool", "input.pool.filterGlassSand" ]    },
        {block: "RECO9",        order: "20.109", rule: ["input.pool.isPool", "input.pool.filterCart" ]    },
        {block: "RECO10",       order: "20.110", rule: ["input.pool.isPool" ]    },
        {block: "RECO11",       order: "20.111", rule: ["input.pool.isPool" ]    },
        {block: "RECO12",       order: "20.112", rule: ["input.pool.isPool" ]    },
        {block: "RECO13",       order: "20.113", rule: ["input.pool.isPool" ]    },
        {block: "RECO14",       order: "20.114", rule: ["input.pool.isPool", "input.pool.saltElect" ]    },
        
        {block: "ALG1",         order: "30.101", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG2",         order: "30.102", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG3",         order: "30.103", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG4",         order: "30.104", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG5",         order: "30.105", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG6",         order: "30.106", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG7",         order: "30.107", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        {block: "ALG8",         order: "30.108", rule: ["input.pool.isPool", "input.options.textAlg", "input.pool.filterGlassSand" ]    },
        {block: "ALG8",         order: "30.108", rule: ["input.pool.isPool", "input.options.textAlg", "input.pool.filterCart" ]    },
        {block: "ALG9",         order: "30.109", rule: ["input.pool.isPool", "input.options.textAlg" ]    },
        
        {block: "TROUBLED1",    order: "40.101", rule: ["input.pool.isPool", "input.options.textTroubled" ]    },
        {block: "TROUBLED2",    order: "40.102", rule: ["input.pool.isPool", "input.options.textTroubled" ]    },
        {block: "TROUBLED3",    order: "40.103", rule: ["input.pool.isPool", "input.options.textTroubled" ]    },
        {block: "TROUBLED4",    order: "40.104", rule: ["input.pool.isPool", "input.options.textTroubled" ]    },
        {block: "TROUBLED5",    order: "40.105", rule: ["input.pool.isPool", "input.options.textTroubled", "input.pool.filterGlassSand" ]    },
        {block: "TROUBLED5",    order: "40.105", rule: ["input.pool.isPool", "input.options.textTroubled", "input.pool.filterCart" ]    },
    ];

    /**
     * Get the value of a variable path
     * @param path {string} the path of the variable (ex : "input.pool.cl")
     * @returns {Diag}
     * @private
     */
    this._getValueFromPath = function(path){
        var aVars = path.split(".");
        var variable = _self;
        aVars.forEach(function (v) {
            if(variable[v] === undefined){
                throw "Can't find "+v+" in path "+path ;
            }
            variable = variable[v];
        });
        return variable ;
    } ;

    /**
     * analyze the rules and return the blocks to print
     * <br><br>
     * You must run {@link diag.Diag#computeVariables} before run this function
     *
     */
    this.applyRules = function () {
        _self.results = [];
        var addedBlock = {} ;
        _self.rules.forEach(function (r) {
            var toAdd = false;
            if (r.rule.length === 0) {
                //no condition, add it
                toAdd = true;
            } else {
                toAdd = true;
                r.rule.forEach(function (ru) {
                    if(!_self._getValueFromPath(ru)){
                        toAdd = false;
                    }
                });
            }

            if(addedBlock[r.block]){
                //already added
                toAdd = false;
            }

            if (toAdd) {
                var order = r.order;
                if (_self.input.options.modeTroubled) {
                    order = r.orderTroubled;
                } else if (_self.input.options.modeAlg) {
                    order = r.orderAlg;
                } else if (_self.input.options.modeColor) {
                    order = r.orderColor;
                }
                _self.results.push({
                    block: r.block,
                    order: order
                });
                addedBlock[r.block] = true ;
            }
        });
        _self.results = _self.results.sort(function (a, b) {
            if (a.order > b.order) {
                return 1;
            } else if (a.order < b.order) {
                return -1;
            } else {
                // a = b
                return 0;
            }
        });
        _self.blockList = Object.keys(addedBlock) ;
    };

    /**
     * Do a full diagnostic
     *
     * @return {Array.<diag.result>} The results of diagnostic
     */
    this.doFullDiag = function () {
        _self.computeVariables();
        return _self.applyRules();
    };
}

module.exports = Diag;
